import { Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from 'react-router-dom';
import { ReCAPTCHAConfig } from '../../../../config/app';
import { DataApi } from '../../../../providers/api-provider';
import { formatCurrency, Loader, postMessageToParent, showError, simpleInputStateHandlerInForm, track } from '../../libs/helpers';
import FundraiseSharer from '../fundraise-seed/FundraiseSharer';
import styles from '../styles/campaign-seed';
import CampaignSeedForm from './CampaignSeedForm';
import SimilarCampaigns from './SimilarCampaigns';


class CampaignSeed extends React.Component {
  constructor(props) {
    super(props);
    this.trackPageCode = 'Campaign Donation'
    track(this.trackPageCode, 'Checkout Opened', '', true);
  }
  state = {
    dataLoading: false,
    loading: false,
    campaign: false,
    done: false,
    similarCampaigns: [],
    recaptchaEnabled: 0,
    recaptcha: '',
    instantDonate: false,
    processedAmount: '',
    donationId: '',
    hearFromFunds: [],
    form: {
      hearFromFundId: 'other',
      donorLike: 1,
      donorComment: '',
    }
  }
  onChange = simpleInputStateHandlerInForm
  recaptchaRef = React.createRef()

  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  performPostSeedAction = async () => {
    const { form, donationId } = this.state
    if (!form.donorComment && form.donorLike && form.hearFromFundId === 'other')
      return postMessageToParent('hide_modal');
    this.setState({ loading: true });
    try {
      await DataApi.update('donor/campaign-online-donations/' + donationId + '/seed-extra-info', form)
      this.setState({ loading: false });
      postMessageToParent('hide_modal');
    }
    catch (error) {
      showError(error);
      console.log(error.message);
      this.setState({ loading: false });
    };
  }
  /* API Call for campaign data*/
  fetchData = async () => {
    this.setState({ dataLoading: true });
    try {
      let res = await DataApi.getOne('campaigns/' + this.props.match.params.slug)
      this.setState({ dataLoading: false, campaign: res.data });
      this.fetchSimilarCampaignsData();
      this.fetchFundData();

    }
    catch (error) {
      showError(error);
      console.log(error.message);
      this.setState({ dataLoading: false });
    };
  }

  fetchSimilarCampaignsData = async () => {
    try {
      let res = await DataApi.getMany('campaigns/' + this.state.campaign.id + '/similar-campaigns');
      this.setState({ similarCampaigns: res.data });
    } catch (e) {
    }
  }
  fetchRecaptchaStateData = async () => {
    try {
      let res = await DataApi.getOne('recaptcha');
      this.setState({ recaptchaEnabled: res.data });
    } catch (e) {
      this.setState({ recaptchaEnabled: true });
    }
  }
  /* API Call for funds list */
  fetchFundData = async () => {
    try {
      let res = await DataApi.getSelect('fundraises', { 'morph_type': 'fund' });
      this.setState({ hearFromFunds: res.data });
    } catch (e) {

    }
  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  async componentDidMount() {
    this.fetchData();
    this.fetchRecaptchaStateData();
  }

  onDonationComplete = (processedAmount, donationId) => {
    const newState = { done: true, instantDonate: false, processedAmount };
    if (donationId)
      newState.donationId = donationId;
    this.setState(newState)
  }

  onDonationFail = () => {
    this.setState({ instantDonate: false })
  }

  performInstantSeedAction = (slug) => {
    this.setState({ instantDonate: slug })
  }
  onGoBackClicked() {
    postMessageToParent('hide_modal');
  }
  renderForm(classes) {
    const { campaign, recaptcha, instantDonate, recaptchaEnabled } = this.state;
    let { trackPageCode, recaptchaRef, onDonationComplete, onDonationFail } = this;
    if (!campaign.donatable) {
      return <Typography align='center' variant="body1" style={{ width: '100%' }}>
        <Typography color='primary' inline variant="body1">{campaign.student.name}</Typography> Campaign is Closed
    </Typography>
    }
    return <CampaignSeedForm {...{
      classes, campaign, trackPageCode, recaptcha, recaptchaRef,
      onDonationComplete, instantDonate, recaptchaEnabled, onDonationFail
    }} />
  }
  renderContainer(dataLoading, campaign, classes) {
    return dataLoading ?
      <div><Loader size='40' /></div>
      : (campaign ? this.renderForm(classes) :
        <Typography align='center' variant="body1" style={{ width: '100%' }}>
          Oops, something went wrong, check your internet please!!
        </Typography>)
  }
  renderDone = () => {
    const { similarCampaigns, processedAmount, instantDonate, form, hearFromFunds, loading } = this.state;
    const { classes } = this.props;
    return (<div className={classes.doneContainer}>
      <Grid container justify="space-between">
        <Grid item xs={9}>
          <Typography variant="h4" className={classes.doneHeader}>
            THANK YOU!
          </Typography>
          <Typography variant="body1" className={classes.doneSubheader}>
            for your generous donation of <span style={{ fontWeight: 700, color: '#6A6A6A' }}>${formatCurrency(processedAmount)}</span><br />
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <img className={'fullwidth'} src={require('../../../../images/post-donation.svg')} />

        </Grid>
      </Grid>
      <div>
        <TextField
          label="Comment"
          value={form.donorComment}
          margin="normal"
          className={classes.dedicationFieldsWarper}
          variant="outlined"

          onChange={this.onChange('donorComment')}
          name='donorComment'
          fullWidth
          inputProps={{ className: 'padding-input' }}
          InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
          InputLabelProps={{ className: ['padding-label', classes.dedicationLabel] }}
        //onBlur={this.props.onFieldBlur('Comment')}
        />

        <FormControl variant="outlined"
          margin="normal"
          className={[classes.formControl, 'fullwidth', classes.dedicationFieldsWarper]}>
          <InputLabel
            htmlFor="hearFromFundId"
          >
            Where did you here about us?
        </InputLabel>
          <Select
            value={form.hearFromFundId}

            input={
              <OutlinedInput
                inputProps={{ className: 'padding-input' }}
                labelWidth={210}
                className={classes.dedicationFields}
                name="hearFromFundId"
                id="hearFromFundId"
                onChange={this.onChange('hearFromFundId')}
              //onBlur={this.onFieldBlur('Reference ID')}
              />
            }
          >
            <MenuItem value="other">Other</MenuItem>
            {Array.isArray(hearFromFunds) && hearFromFunds.map(function (i) { return <MenuItem key={'hear-from-funds-' + i.id} value={i.id}>{i.name}</MenuItem> })}
          </Select>
        </FormControl>
        <div className='fullwidth'>
          <FormControlLabel
            margin="normal"
            control={
              <Checkbox
                checked={form.donorLike}
                value="1"
                name='donorLike'
                color="primary"
                className='tbpadding-5'
                onChange={this.onChange('donorLike')}
              //onBlur={this.onFieldBlur('Like')}
              />
            }
            label={<div class='row'><Typography >Follow this campaign</Typography></div>}
          />
        </div>
        <Button fullWidth onClick={this.performPostSeedAction} variant="contained" className={classes.postSeedButton} disabled={loading}>
          {loading ? <Loader /> :
            (form.donorComment || !form.donorLike || form.hearFromFundId !== 'other' ? 'Save and continue browsing' : 'Continue browsing')
          }
        </Button>
        <FundraiseSharer classes={classes} />

      </div>
      <SimilarCampaigns data={similarCampaigns}
        performInstantSeedAction={this.performInstantSeedAction}
        amount={processedAmount}
        instantDonate={instantDonate}
      />
    </div>);
  }
  /* Render Page */
  render() {
    const { classes } = this.props;
    const { recaptchaEnabled, dataLoading, campaign, done, similarCampaigns,
      processedAmount, instantDonate, form } = this.state;
    return (
      <main className={[classes.main]}>
        <CssBaseline />
        <Paper className={classes.paper + ' seed-page-paper'} style={{ backgroundColor: '#fffffff1' }}>

          <div className={done ? 'd-none' : 'fullwidth'}>
            {this.renderContainer(dataLoading, campaign, classes)}
          </div>
          {done && this.renderDone()}
          {recaptchaEnabled !== 0 &&
            <ReCAPTCHA
              sitekey={ReCAPTCHAConfig.site_key_invisible}
              size="invisible"
              ref={this.recaptchaRef}
            />
          }
        </Paper>
      </main>
    );
  }
}

CampaignSeed.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withRouter(CampaignSeed));
